import { axiosInstance } from ".";

const BASE_PATH = "/training_working_slots";

const getTrainingWorkingSlotsList = async (params) =>
  await axiosInstance.get(BASE_PATH, { params });

const addTrainingWorkingSlot = async ({ data }) =>
  await axiosInstance.post(BASE_PATH, data, { handlerEnabled: false });

const editTrainingWorkingSlot = async ({ id, data }) =>
  await axiosInstance.patch(`${BASE_PATH}/${id}`, data, { handlerEnabled: false });

const deleteTrainingWorkingSlot = async ({ id }) =>
  await axiosInstance.delete(`${BASE_PATH}/${id}`);

export {
  getTrainingWorkingSlotsList,
  addTrainingWorkingSlot,
  editTrainingWorkingSlot,
  deleteTrainingWorkingSlot,
};
